import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<undefined>('DELETE', `${APIV2_URL}/listing/${listingId}`);
